import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class PagosService 
{
    constructor(private http: HttpClient) { }

    traePostulaciones(idProducto: any)
    {
        return  this.http.get(`${environment.urlApipagos}/postulaciones/agrupproductos/${idProducto}`, 
                { headers: this.armaCabecera() } ).toPromise()
    }

    creaGrupoPago(fechaPago: any,fechaContable: any, idUsuarioAgrupa: any, postulaciones: any)
    {       
        return  this.http.post(`${environment.urlApipagos}/agrupaciones/postulaciones/`, 
                {
                    fechaPagoEstimada: fechaPago,
                    fechaContable: fechaContable,
                    idUsuarioAgrupa: idUsuarioAgrupa,
                    postulacion: postulaciones
                }, 
                { headers: this.armaCabecera() } ).toPromise()
    }

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}